import React, { useEffect, useState } from 'react';
import { HolographicButton } from './HolographicButton';
export function StickyMobileCTA() {
  const [show, setShow] = useState(false);
  const CHECKOUT_URL = 'https://emalia.lat/cart/48340125352186:1';
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      if (window.scrollY > 600) {
        setShow(true);
      } else {
        setShow(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!show) return null;
  return <div className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 p-3 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50 md:hidden animate-slide-up" data-id="element-188">
      <div className="flex items-center justify-between gap-4" data-id="element-189">
        <div className="flex flex-col" data-id="element-190">
          <span className="text-xs text-gray-500" data-id="element-191">Garantía 7 días</span>
          <span className="font-bold text-secondary text-lg" data-id="element-192">$29.999</span>
        </div>
        <HolographicButton href={CHECKOUT_URL} size="md" className="flex-1 text-sm py-3" data-id="element-193">
          Comprar ahora
        </HolographicButton>
      </div>
    </div>;
}